import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Header from '../components/layout/header';
import './home.css';
import search from '../assets/icons/search.svg';
import listing1 from '../assets/icons/event1.svg';
import listing2 from '../assets/icons/event2.svg';
import listing3 from '../assets/icons/event3.svg';
import Preloader from '../components/layout/preloader';
import Card1 from '../components/common/card1';
import SecTitle from '../components/common/secTitle';
import Card2 from '../components/common/card2';
import eventImg1 from '../assets/imgs/cardImg1.jpg';
import eventImg2 from '../assets/imgs/cardImg2.jpg';
import eventImg3 from '../assets/imgs/cardImg3.jpg';
import eventImg4 from '../assets/imgs/cardImg4.jpg';
import eventImg5 from '../assets/imgs/cardImg5.jpg';
import eventImg6 from '../assets/imgs/cardImg6.jpg';
import star from '../assets/icons/star.svg';
import feat from '../assets/imgs/featImg.jpg';
import calendar from '../assets/icons/calendar.svg';
import pin from '../assets/icons/map.svg';
import '../components/common/card2.css';
import Button from '../components/common/btn';
import CurvedLoop from '../assets/animation/CurvedLoop';
import Booking from '../components/common/booking';
import ReviewCard from '../components/common/reviewCard';
import Footer from '../components/layout/footer';
import { useTranslation } from 'react-i18next';

const Home = () => {

    const [loading, setLoading] = useState(true)
    const { t, i18n } = useTranslation();

    useEffect(() => {
      const lang = i18n.language;
      const dir = lang === "ar" ? "rtl" : "ltr";
      document.documentElement.lang = lang;
      document.documentElement.dir = dir;
    }, [i18n.language]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false)
      }, 2000)
  
      return () => clearTimeout(timer)
    },)
  
    if (loading) {
      return <Preloader />
    }
    

    return ( 
        <>
        <Header />
        <main>
            <div className="bgGrid"></div>
            <section id='home' className="hero">
                <div className="heroCont">
                    <h1 className='heading weight4'>{t("Step beyond the page")}</h1>
                    <h4 className='body weight4'>{t("Discover curated literary events—from intimate book clubs to grand festivals. Connect with authors, readers, and storytellers in your city.")}</h4>
                </div>
                <div className="searchBar">
                    <img className='magrin' src={search} alt="search icon" />
                    <input className='body' type="text" placeholder={t("Search by book, author, or event...")}/>
                    <button className='body'>{t("Explore Events")}</button>
                </div>
            </section>
            <section id='listing' className='sec'>
                <SecTitle secTitle={t("Explore Literary Worlds")} />
                <div className="listings">
                    <Card1 listingImg={listing1} listingTitle={t("Book Clubs")} listingDesc={t("Intimate discussions over shared stories")} />
                    <Card1 listingImg={listing2} listingTitle={t("Poetry Nights")} listingDesc={t("Verse spoken, hearts opened")} />
                    <Card1 listingImg={listing3} listingTitle={t("Writing Workshops")} listingDesc={t("Craft your own narrative")} />
                </div>
            </section>
            <section id='upcoming' className='sec'>
                <SecTitle secTitle={t("Upcoming Events")} />
                <div className="events">
                    <Card2 eventImg={eventImg1} eventCategory={t("Book Club")} eventTitle={t("Midnight Pages Book Club")} eventDate={t("May 15, 2026")} eventLoc={t("Bookworm Café")} eventPrice={t("$15")} />
                    <Card2 eventImg={eventImg2} eventCategory={t("Poetry Night")} eventTitle={t("Poetry Under Stars")} eventDate={t("May 20, 2026")} eventLoc={t("Garden Theatre")} eventPrice={t("$20")} />
                    <Card2 eventImg={eventImg3} eventCategory={t("Workshop")} eventTitle={t("Creative Writing Workshop")} eventDate={t("May 22, 2026")} eventLoc={t("The Writer’s Hub")} eventPrice={t("$35")} />
                    <Card2 eventImg={eventImg4} eventCategory={t("Author Talk")} eventTitle={t("Meet the Author: Rasha Zidan")} eventDate={t("May 25, 2026")} eventLoc={t("Diwan Bookstore")} eventPrice={t("Free")} />
                    <Card2 eventImg={eventImg5} eventCategory={t("Community")} eventTitle={t("Bookish Brunch Gathering")} eventDate={t("May 28, 2026")} eventLoc={t("Prose & Coffee")} eventPrice={t("$25")} />
                    <Card2 eventImg={eventImg6} eventCategory={t("Festival")} eventTitle={t("Annual Literary Festival")} eventDate={t("June 13, 2026")} eventLoc={t("City Center")} eventPrice={t("$50")} />
                </div>
            </section>
            <section id='featured' className='sec'>
                <SecTitle secTitle={t("Featured Events")} />
                <div className="card3">
                    <img className='featImg' src={feat} alt="card img" />
                    <div className="card3Cont">
                        <div className="card2Category card3Category">
                            <img src={star} alt="star icon" />
                            <p className='body'>{t("Featured Event")}</p>
                        </div>
                        <h2 className='heading'>{t("Literary Festival 2026")}</h2>
                        <h6 className='body'>{t("Join us for three days of literary celebration featuring renowned authors, panel discussions, workshops, and book signings. A must-attend event for book lovers!")}</h6>
                        <div className="card2Det">
                            <img src={calendar} alt="calendar icon" />
                            <h6 className='body'>{t("June 13, 2026")}</h6>
                        </div>
                        <div className="card2Det">
                            <img src={pin} alt="pin icon" />
                            <h6 className='body'>{t("City Center Plaza")}</h6>
                        </div>
                        <Button btnText={t("Book Now")} />
                    </div>
                </div>
            </section>
            <section id='about' className='sec'>
                <SecTitle secTitle={t("About Spine")} />
                <h4 className='textCenter brinnanReg body primaryText'>{t("Spine is your gateway to the vibrant world of literary events. We aggregate bookish gatherings from bookstores, libraries, and cultural spaces across your city. Whether you're seeking intimate book clubs, inspiring workshops, or grand literary festivals, we bring the reading community together in one beautiful place.")}</h4>
            </section>
            <CurvedLoop marqueeText={t("THE ✦ BEST ✦ BOOKISH ✦ EVENTS ✦ PLATFORM ✦")} interactive speed = {1} />
            <section className='sec'>
                <Booking />
            </section>
            <section id='reviews' className='sec flexWrap'>
                <SecTitle secTitle={t("What Readers Say")} />
                <div className="events2">
                    <ReviewCard review={t("The best platform for finding literary events. Absolutely love it!")} reviewer={t("James Park")} />
                    <ReviewCard review={t("Spine helped me discover amazing book clubs in my neighborhood!")} reviewer={t("Emma Rodriguez")} />
                    <ReviewCard review={t("Finally, a place that brings readers and writers together.")} reviewer={t("Leila Hassan")} />
                </div>
            </section>
            <section id='subscribe' className='sec'>
                <div className="newsletter">
                    <div className="title">
                        <SecTitle secTitle={t("Stay in the Loop")} />
                        <h5 className='body'>{t("Get weekly literary events delivered to your inbox")}</h5>
                    </div>
                    <div className="row">
                        <input className='body' type="email" placeholder={t('Enter your email')} />
                        <Button btnText={t("Subscribe")} />
                    </div>
                </div>
            </section>
            <Footer />
        </main>
        </>
     );
}
 
export default Home;